import { getStringHash, seededRandom } from '@/utils';

import './index.less';

interface NameIconProps {
  name: string;
  shape?: 'circle' | 'square';
  styles?: React.CSSProperties;
  random?: boolean;
}

const colorSets = [
  {
    txt: '#F0FEFF',
    bg: '#2DC7CD',
  },
  {
    txt: '#0A2361',
    bg: 'var(--superapp-secondary-1)',
  },
];

const NameIcon = (props: NameIconProps) => {
  const { name, styles = {}, shape = 'circle', random } = props;

  const nameHash = getStringHash(name);

  const { txt, bg } = random ? colorSets[seededRandom(nameHash, 1, 0)] : colorSets[0];

  let content = '';
  if (name?.length) {
    content = name.charAt(0);
  }

  return (
    <div className={`style-icon ${shape}`} style={{ color: txt, backgroundColor: bg, ...styles }}>
      {content}
    </div>
  );
};

export default NameIcon;
